import { Box, ButtonProps, Card, CardContent, CardHeader, CardProps, Grid, Theme, Typography } from '@mui/material';
import * as styles from '@pages/NewQuote/PanelBase/PanelBase.styles';
import { Button } from '@components/button';
import { CheckCircleSolid, Circle, Pen } from '@assets/svgs';

export enum PanelBaseType {
  Closed = 'closed',
  Open = 'open',
}

interface IPanelBase extends CardProps {
  name: string;
  step?: string;
  type: PanelBaseType;
  onEdit?: () => void;
  confirmButtonProps?: ButtonProps & { isLoading?: boolean };
  mode?: 'dense' | 'normal';
}

export const PanelBase = (props: IPanelBase) => {
  const { name, step, onEdit, type, children, confirmButtonProps, mode, ...other } = props;

  const isOpen = type === PanelBaseType.Open;
  return (
    <>
      <Card
        elevation={0}
        sx={[
          styles.basePanel,
          mode === 'dense'
            ? {
                marginBottom: '0px !important',
                paddingBottom: '0px !important',
              }
            : {},
          {
            '&.MuiPaper-elevation0': {
              '&.MuiCard-root': {
                backgroundColor: isOpen ? 'panel.main' : 'transparent',
                boxShadow: isOpen ? 'boxShadow.3' : 'none',
                borderRadius: !isOpen ? 0 : '8px',
                borderTop: !isOpen ? `1px solid gray` : 'none',
                borderColor: 'other.divider',
                '&:hover': {
                  backgroundColor: (theme) => (!isOpen ? `${theme.palette.text.main}30` : 'none'),
                  borderRadius: (theme) => theme.shape.borderRadius * 2,
                  '#edit-button': {
                    visibility: !isOpen ? 'visible' : 'hidden',
                  },
                },
              },
            },
          },
        ]}
        {...other}
      >
        {mode !== 'dense' && (
          <CardHeader
            disableTypography
            title={
              <>
                <Grid
                  sx={{
                    color: ({ palette }: Theme) => (isOpen ? palette.text.subdued : palette.common.white),
                    svg: { fill: ({ palette }: Theme) => (isOpen ? palette.text.subdued : palette.common.white) },
                  }}
                >
                  {!isOpen ? <CheckCircleSolid id='check-circle-solid-icon' /> : <Circle id='circle-icon' />}
                </Grid>
                <Typography variant='h6'>{name}</Typography>
                {step ? (
                  <Typography variant='bodySmall' sx={{ padding: '2px' }}>
                    &nbsp;{step}
                  </Typography>
                ) : null}
              </>
            }
            action={
              onEdit ? (
                <Button
                  id='edit-button'
                  startIcon={<Pen width='16px' height='16px' style={{ color: 'accent.tertiary' }} />}
                  variant='text'
                  onClick={onEdit}
                >
                  Edit
                </Button>
              ) : null
            }
          />
        )}
        <CardContent>{children}</CardContent>
      </Card>
      {confirmButtonProps ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '18px',
          }}
        >
          <Button variant='contained' {...(confirmButtonProps as any)} />
        </Box>
      ) : null}
    </>
  );
};
